define('pages/claim/ServiceLine/ServiceLineComponent',[
	'jquery',
	'core/can',
	'models/ServiceLine',
	'template!pages/claim/ServiceLine/ServiceLineView.stache',
	'moment',
	'../../../../lib/jquery-ui/ui/sortable',
	'jquery-throttle'
], function($, can, ServiceLine, template, moment) {

	function allEmpty(els) {
		for (var i=0; i<els.length; i++)
			if (els.eq(i).val().length !== 0 && els.eq(i).val() !== '0')
				return false;
		return true;
	}

	function makeTotalCompute(claim, key) {
		return can.compute(function() {
			var lines = claim.attr('ServiceLines'),
				total = 0;
			for (var i=0; i<lines.attr('length'); i++) {
				total += parseFloat(lines.attr(i).attr(key), 10) || 0;
			}
			return (Math.round(total) === total) ? total : total.toFixed(2);
		})
	}

	return can.Component.extend({

		tag: 'claim-servicelines',

		template: can.view(template),

		scope: function(attrs, scope, el) {
			return {
				Claim: attrs.claim,

				TotalCharges: makeTotalCompute(attrs.claim, 'Charges'),

				TotalNonCoveredCharges: makeTotalCompute(attrs.claim, 'NonCoveredCharges'),

				isLastRowProcedure: can.compute(function() {
					var lines = attrs.claim.attr('ServiceLines'),
						last = lines.attr('length') - 1;
					if (last < 0) return false;
					return lines.attr(last).attr('_isProcedure');
				}),

				isReordering: false,

				hasMultiple: can.compute(function() {
					return this.attr('Claim.ServiceLines').attr('length') > 1;
				}),

				selected: [],
				selectedAtleastOne: can.compute(function() {
					return this.attr('selected').attr('length') > 0;
				}),
				selectedMultiple: can.compute(function() {
					return this.attr('selected').attr('length') > 1;
				})
			}
		},

		events: {

			'inserted': function(el, ev) {

				// Sortable
				var lines = this.scope.attr('Claim.ServiceLines'),
					startIndex;
				el.find('tbody').sortable({
					containment: el.find('table'),
					handle: '.handle',
					start: function(ev, ui) {
						startIndex = ui.item.index();
						ui.item.addClass('isSorting');
						ui.placeholder.height(ui.helper.outerHeight());
					},
					stop: function(ev, ui) {
						ui.item.removeClass('isSorting');
						var stopIndex = ui.item.index();
						if (startIndex !== stopIndex) {
							lines.splice(stopIndex, 0, lines.splice(startIndex, 1)[0]);
						}
					}
				});

				// Sticky Menu
				var $panel = el.find('.panel');

				$(window).scroll($.throttle(100, function() {

					var $table = $panel.find('.table'),
						$tr = $table.find('tbody tr:first'),
						$footer = $panel.find('.panel-footer'),

						footerHeight = $footer.outerHeight(),

						ceiling = $table.offset().top + $table.outerHeight() + footerHeight,
						floor = $tr.offset().top + $tr.outerHeight() + footerHeight,

						windowBottom = window.scrollY + window.innerHeight;

					if (floor < windowBottom && windowBottom < ceiling) {

						if (!$footer.hasClass('stuck')) {
							$footer
								.addClass('stuck')
								.css('bottom', -1 * footerHeight);
						}

						$footer.stop(true).animate({
							bottom: ceiling - windowBottom - footerHeight
						}, 100, 'linear');

					} else if ($footer.hasClass('stuck')) {
						$footer.removeClass('stuck');
					}
				}));
			},

			'{Claim} StartDate': function(map, ev, val) {
				this.setDatepickerRange($('[can-datepicker="ServiceDateFrom"]'));
			},

			'.sl-add click': function() {
				this.addServiceLine();
				//this.focusServiceLine();
			},

			'.sl-add-copy, .sl-add-qcodes click': 'duplicateRows',

			duplicateRows: function(el, ev) {
				var scope = this.scope,
					lines = scope.attr('Claim.ServiceLines'),
					selected = scope.attr('selected').attr().sort(),
					qCode = el.data('q'),
					isQcode = qCode !== undefined;

				for(var i = selected.length-1; i >= 0; i--){
					var selectedLine = lines.attr(selected[i]);
					this.addServiceLine({
						RevenueCode: selectedLine.attr('RevenueCode'),
						Description: isQcode ? 'Location Code' : selectedLine.attr('Description'),
						HcpcsCode: isQcode ? qCode : selectedLine.attr('HcpcsCode'),
						ServiceDateFrom: isQcode ? selectedLine.attr('ServiceDateFrom') : "",
						Units: isQcode ? 1 : selectedLine.attr('Units'),
						Charges: isQcode ? 0.01 : selectedLine.attr('Charges'),
						NonCoveredCharges: isQcode ? "" : selectedLine.attr('NonCoveredCharges')
					}, selected[i]);
				}

				this.clearSelected();
			},

			addServiceLine: function(attrs, index) {
				if (attrs === undefined) attrs = {};
				var lines = this.scope.attr('Claim.ServiceLines');
				if (lines.length <= 448) {

					// Add ServiceLine to list
					if (index === undefined) {
						lines.push(attrs);
					} else {
						lines.splice(index+1, 0, attrs);
					}

					// Set datepicker range
					var eq = ((index !== undefined) ? index : (lines.attr('length')-1)),
						el = $('[can-datepicker="ServiceDateFrom"]').eq(eq)
					this.setDatepickerRange(el);

				} else {
					App.alert({
						title: 'Too many!',
						message: 'AxxessDDE can take at most 448 service entries.'
					});
				}
			},

			clearSelected: function() {
				this.scope.attr('selected').replace([]);
				this.element.find('tr').removeClass('selected');
			},
/*
			focusServiceLine: function(index) {
				var lines = this.element.find('tbody tr'),
					line = (index === undefined) ? lines.last() : lines.eq(index);
				line.find('input:first').focus();
			},
*/

			// Order Rows

			'.sl-reorder click': function() {
				this.scope.attr('isReordering', true);
				this.clearSelected();
			},

			'.sl-reorder-done click': function() {
				this.scope.attr('isReordering', false);
			},

			'.sl-delete click': function(el, ev) {
				var self = this,
					scope = this.scope,
					selected = scope.attr('selected').attr().sort(),
					ServiceLines = this.scope.attr('Claim.ServiceLines');

				App.confirm({
					title: 'Delete Service Line',
					message: 'Are you sure you want to delete '
						+ (this.scope.attr('hasMultiple') ? 'these service lines' : 'this service line')
						+ '? This cannot be undone.',
					ok: function() {
						for (var i = selected.length-1; i >= 0; i--) {
							ServiceLines.splice(selected[i], 1);
						}
						self.clearSelected();
					}
				});
			},

			setDatepickerRange: function(el) {
				var date = this.scope.attr('Claim.StartDate');
				if (date !== undefined) {
					var start = moment.utc(date),
						end = moment.utc(start).add(59, 'd');
					el.datepicker('setStartDate', new Date(start.format('YYYY-MM-DD HH:mm')));
					el.datepicker('setEndDate', new Date(end.format('YYYY-MM-DD HH:mm')));
				}
			},

			// Selecting Rows
			'td click': function(el, ev) {
				if (ev.target.tagName.toLowerCase() === 'td') {

					var selected = this.scope.attr('selected');

					if (ev.ctrlKey || ev.metaKey) {

						var cb = el.parent().find('[type="checkbox"]'),
							checked = cb.prop('checked');
						cb.prop('checked', !checked).change();

					} else if (ev.shiftKey && selected.length) {

						var previous = selected[selected.length - 1],
							current = el.parent().index(),
							start = Math.min(previous, current) + 1,
							stop = Math.max(previous, current) + 1,
							tbody = el.closest('tbody');
						tbody.find('tr:nth-child(n+'+start+'):nth-child(-n+'+stop+') input[type="checkbox"]').prop('checked', true).change();

					} else {

						var tr = el.parent(),
							cb = tr.find('[type="checkbox"]')
							cbs = tr.parent().find('[type="checkbox"]');

						cb.prop('checked', true);
						cbs.not(cb).prop('checked', false);
						cbs.change();
					}
				}
			},

			'.has-feedback focusin': function(el, ev) {
				var tr = el.closest('tr');

				if(tr.hasClass('danger')) {
					$('.form-control-feedback').tooltip('show');
				}
			},

			'.has-feedback focusout': function(el, ev) {
				var tr = el.closest('tr');
				if(tr.hasClass('danger') && !el.find('.form-control-feedback').hasClass('first-show')) {
					$('.form-control-feedback').tooltip('hide');
				}
			},

			'input[type="checkbox"] change': function(el, ev) {
				var tr = el.closest('tr'),
					index = tr.index(),
					selected = this.scope.attr('selected');
				if (el.prop('checked')) {
					var found = false;
					for (var i=0; i<selected.length; i++) {
						if (selected[i] === index) {
							found = true;
						}
					}
					if (!found) {
						selected.push(index);
						tr.addClass('selected');
					}
				} else {
					for (var i=0; i<selected.length; i++) {
						if (selected[i] === index) {
							selected.splice(i, 1);
							tr.removeClass('selected');
							break;
						}
					}
				}
			}
		}

	});

	// TODO HCPCS ax-tooltip="Healthcare Common Procedure Coding System"
});

